import { Injectable } from '@angular/core';
import { forkJoin, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PermissionErrorHandlerService } from '@nimbus-global/features/shared/services/domain/permission-error-handler.service';
import { AdministrationGroupInfoResponseModel } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/administration-group-info.response-model';
import { AdministrationGroupMemberItemResponseModel } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/administration-group-member-item.response-model';
import { AdministrationGroupViewModel } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/administration-group.view-model';
import { ToAdministrationGroupViewModelMapper } from '@nimbus-library/features/shared/components/material/input-administration-security-group/models/to-administration-group-view-model.mapper';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';

const ROUTES = {
  GetAdministrationGroupName(guid: string, tenantId: string): string {
    return `ms-graph-api-adapter/v1/groups/${guid}/security-group?tenantId=${tenantId}`;
  },
  GetAdministrationGroupMembers(guid: string, tenantId: string): string {
    return `ms-graph-api-adapter/v1/groups/${guid}/security-group/members?tenantId=${tenantId}`;
  },
};

@Injectable()
export class SecurityGroupService {
  public constructor(
    private readonly httpService: BaseHttpService,
    private readonly permissionErrorHandlerService: PermissionErrorHandlerService,
  ) {}

  public getAdministrationGroupInformation(guid: string, tenantId: string): Observable<AdministrationGroupViewModel> {
    return forkJoin([this.getAdministrationGroupName(guid, tenantId), this.getAdministrationGroupMembers(guid, tenantId)]).pipe(
      map(([groupInfo, members]) => new ToAdministrationGroupViewModelMapper().handle(groupInfo, members)),
      catchError((err) => throwError(this.permissionErrorHandlerService.handle(err))),
    );
  }

  public getAdministrationGroupName(guid: string, tenantId: string): Observable<AdministrationGroupInfoResponseModel> {
    return this.httpService.get(ROUTES.GetAdministrationGroupName(guid, tenantId));
  }

  public getAdministrationGroupMembers(guid: string, tenantId: string): Observable<AdministrationGroupMemberItemResponseModel[]> {
    return this.httpService.get(ROUTES.GetAdministrationGroupMembers(guid, tenantId));
  }
}
